// File: src/config.js
const API_BASE_URL = "https://web1024.docmaster.in:5007/api"; // Update this URL as needed
//export const SCHOOL_QUIZ_API_BASE_URL = "https://web1024.ipguide.net:5007/api/school/quiz/admin";
export const SCHOOL_QUIZ_API_BASE_URL =
  "https://web1024.docmaster.in:5007/api/school/quiz/admin";
// "http://192.168.0.219:5007/api/school/quiz/admin";

// const API_BASE_URL = "http://192.168.0.18:5007/api"; // Update this URL as needed
//const API_BASE_URL = 'http://localhost:5007/api'; // Update this URL as needed
export const BoardMedium_URL = `${API_BASE_URL}/board`;
export default API_BASE_URL;
export const getAgeGrps =
  "https://web1024.docmaster.in:5007/api/school/quiz/admin/get-age-groups";
export const getCount =
  "https://web1024.docmaster.in/api/school/quiz/admin/get-count";
export const getCountDetails =
  "https://web1024.docmaster.in:5007/api/school/quiz/admin/get-count";

export const BoardStatusUpdateAPI = `${API_BASE_URL}/board/update-status`;
